module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("adEXg"))).then(() => parcelRequire('8rm4T'));